import React from "react";

/**
 * Cabeçalho padrão do SaaS no estilo Next Fit.
 * Uso:
 *   <PageHeader title="Alunos" subtitle="..." actions={<Button/>} tabs={[{key,label,icon}]} activeTab tab onTabChange/>
 */
export function PageHeader({ title, subtitle, badge, actions, tabs, activeTab, onTabChange }) {
  return (
    <div className="bg-white border border-slate-200 rounded-xl overflow-hidden">
      <div className="px-6 py-5 flex items-start justify-between flex-wrap gap-4">
        <div className="min-w-0">
          <div className="flex items-center gap-3 flex-wrap">
            <h1 className="font-heading text-2xl md:text-3xl font-extrabold text-slate-900 uppercase tracking-tight">{title}</h1>
            {badge}
          </div>
          {subtitle && <p className="text-sm text-slate-500 mt-1">{subtitle}</p>}
        </div>
        {actions && <div className="flex items-center gap-2 flex-wrap">{actions}</div>}
      </div>
      {tabs && tabs.length > 0 && (
        <div className="border-t border-slate-200 overflow-x-auto">
          <div className="flex items-center gap-1 min-w-max px-2">
            {tabs.map(t => {
              const Icon = t.icon; const active = activeTab === t.key;
              return (
                <button key={t.key} onClick={()=>onTabChange && onTabChange(t.key)} data-testid={`tab-${t.key}`}
                  className={`px-4 py-3 text-xs md:text-sm font-bold uppercase tracking-wider transition-all border-b-2 flex items-center gap-1.5 whitespace-nowrap ${active ? "text-rose-600 border-rose-600" : "text-slate-500 border-transparent hover:text-slate-900"}`}>
                  {Icon && <Icon className="w-4 h-4"/>}{t.label}
                </button>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}

export function StatusBadge({ status, size = "sm" }) {
  const map = {
    active: { label: "Ativo", bg: "bg-emerald-500", text: "text-white", border: "" },
    paid: { label: "Pago", bg: "bg-emerald-500", text: "text-white", border: "" },
    pending: { label: "Pendente", bg: "bg-amber-400", text: "text-amber-900", border: "" },
    // Inativo/Encerrado agora têm contorno vermelho (visível no modo escuro)
    inactive: { label: "Inativo", bg: "bg-slate-300 dark:bg-slate-800", text: "text-rose-700 dark:text-rose-400", border: "border-2 border-rose-500" },
    encerrado: { label: "Encerrado", bg: "bg-slate-300 dark:bg-slate-800", text: "text-rose-700 dark:text-rose-400", border: "border-2 border-rose-500" },
    suspenso: { label: "Suspenso", bg: "bg-amber-100", text: "text-amber-800", border: "" },
    blocked: { label: "Bloqueado", bg: "bg-rose-500", text: "text-white", border: "" },
  };
  const s = map[status] || map.inactive;
  const cls = size === "lg" ? "px-8 py-2 text-xs" : "px-3 py-1 text-xs";
  return <span className={`inline-block ${cls} rounded-lg ${s.bg} ${s.text} ${s.border} font-bold uppercase tracking-wider`}>{s.label}</span>;
}

export function MethodBadge({ method }) {
  const map = {
    cash: { label: "Dinheiro", color: "#10B981" },
    card: { label: "Cartão", color: "#3B82F6" },
    pix: { label: "Pix", color: "#E11D48" },
    manual: { label: "Manual", color: "#F59E0B" },
    stripe: { label: "Stripe", color: "#6366F1" },
  };
  const m = map[method] || { label: method, color: "#64748b" };
  return <span className="text-xs px-2 py-1 rounded-full font-semibold" style={{ background: m.color + "1a", color: m.color }}>{m.label}</span>;
}

export function TableCard({ children }) {
  return <div className="bg-white rounded-xl border border-slate-200 overflow-x-auto">{children}</div>;
}
